import { getCookie } from '../dbconnector/checktoken'
import { getserverurl } from '../dbconnector/connector';



const saveFile = async (file, type, link_Id) => {
  console.log("item : ", file)
  console.log("type : ", type)
  console.log(" user.id : ", link_Id)
  const Bearer = await getCookie("logintoken")
  const url = await getserverurl();
  const formData = new FormData();
  //console.log("file", file)
  formData.append('file', file);
  formData.append('type', type);
  formData.append('link_Id', link_Id);
  const response = await fetch(url + 'api/files/upload', {
    method: 'POST',
    body: formData,
    headers: {
      "Token": "Bearer " + Bearer,
    }
  });
  const data = await response.json();
  console.log("return =", data)
  return data;
}


const downloadfile = async (filename) => {
  const Bearer = await getCookie("logintoken")
  const url = getserverurl();
  const response = await fetch(url + 'api/files/download/' + filename, {
    method: 'GET',
    headers: {
      "Token": "Bearer " + Bearer,
    }
  });
  const data = await response.blob();
  return data;
}

const getfiles = async (type, link_Id) => {
  const Bearer = await getCookie("logintoken")
  const url = getserverurl();
  const response = await fetch(url + 'api/files/getdocuments/' + link_Id + '/' + type, {
    method: 'GET',
    headers: {
      "Token": "Bearer " + Bearer,
    }
  });
  const data = await response.json();
  return data;
}
const getfilesurl = async (type, link_Id) => {

  const Bearer = await getCookie("logintoken")
  const url = getserverurl();
  const response = await fetch(url + 'api/files/getdocumentsurl/' + link_Id + '/' + type, {
    method: 'GET',
    headers: {
      "Token": "Bearer " + Bearer,
    }
  });

  const data = await response.json();
  //console.log("getfilesurl :", data)
  return data;
}
const deletefile = async (id, type) => {
  const Bearer = await getCookie("logintoken")
  const url = getserverurl();
  return fetch(url + "api/files/" + id + "/" + type, {
    method: "DELETE",
    headers: {
      "Token": "Bearer " + Bearer
    }
  })
}

const createdoctype = async (test) => {
  const Bearer = await getCookie("logintoken")
  const url = await getserverurl();
  console.log(test)
  return await fetch(url + 'api/files/createtype', {
    method: 'POST',
    body: JSON.stringify({
      "name": test
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json"
    }
  });

}

const changedoctype = async (description, id) => {

  const Bearer = await getCookie("logintoken")
  const url = await getserverurl();
  return await fetch(url + 'api/files/changetypedescription', {
    method: 'POST',
    body: JSON.stringify({
      "name": description,
      "id": id
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json"
    }
  });

}
const deletedoctype = async (id) => {

  const Bearer = await getCookie("logintoken")
  const url = await getserverurl();
  console.log("id:", id)
  return await fetch(url + 'api/files/deletetype', {
    method: 'POST',
    body: JSON.stringify({
      "id": id
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json"
    }
  });

}

const CheckFileExists = async (filepath) => {

  // const Bearer = await getCookie("logintoken")
  // const url = await getserverurl();
  // console.log("filepath:", filepath)
  // //return true
  // return await fetch(url + 'api/files/fileexists/'+filepath, {
  //   method: 'GET',
  //   headers: {
  //     "Token": "Bearer " + Bearer,
  //     "Content-type": "application/json"
  //   }
  // });

}



// const updateEmployeedata = async (user) => {
//   user = formatdates(user);
//   const Bearer = await getCookie("logintoken")
//   const response = await fetch(baseurl + "/employee/" + user.id, {
//     method: "put",
//     body: JSON.stringify({
//       ...user
//     }),
//     headers: {
//       "Content-type": "application/json",
//       "Token": "Bearer " + Bearer,
//     }
//   });
//   return response

// }

export { saveFile, downloadfile, getfiles, deletefile, getfilesurl, createdoctype, changedoctype, deletedoctype, CheckFileExists }